export default {
  '作业列表':'作業列表',
  '请选择班级':'請選擇班級',
  '作业标题、发布人模糊搜索':'作業標題、發佈人模糊搜索',
  '发布作业':'發佈作業',

  '到':'至',
  '提前结束':'提前結束',
  '作业标题':'作業標題',
  '接收班级':'接收班級',
  '发布人':'發佈人',
  '作业周期':'作業週期',
  '确认要删除{workName}吗？':'確認要刪除{workName}嗎？',

  '删除后，无法查看该作业！':'刪除後，無法查看該作業！',
  '{workName}删除成功！':'{workName}刪除成功！',
  '确认要提前结束{workName}吗？':'確認要提前結束{workName}嗎？',
  '结束后，用户将不能继续参与作业！':'結束後，用戶將不能繼續參與作業！',
  '{workName}提前终止成功！':'{workName}提前終止成功！',

  '编辑作业':'編輯作業',
  '查看作业':'查看作業',
  '作业详情':'作業詳情',
  '作业内容':'作業內容',
  '详情':'詳情',
  '明细':'明細',
  '数据':'數據',
  '发布作业':'發佈作業',
  '填写基本信息':'填寫基本資訊',
  '配置作业内容':'配置作業內容',
  '基础信息':'基礎資訊',
  '作业名称':'作業名稱',
  '请输入作业名称':'請輸入作業名稱',
  '周期':'週期',
  '范围':'範圍',
  '请选择周期':'請選擇週期',
  '请选择范围':'請選擇範圍',

  '配置运动项目':'配置運動項目',
  '每天重复':'每天重複',
  '每周重复':'每周重複',
  '布置方式':'佈置方式',
  '增加项目':'增加項目',
  '选择项目':'選擇項目',
  '运动方式':'運動方式',
  '支持特殊项目':'支援特殊項目',
  '强度':'強度',
  '分':'分',
  '至':'至',
  '秒':'秒',
  '组数':'組數',
  '组':'組',

  '项目名':'項目名',
  '运动强度':'運動強度',
  '周一':'週一',
  '周二':'週二',
  '周三':'週三',
  '周四':'週四',
  '周五':'週五',
  '周六':'週六',
  '周日':'週日',
  '热身':'熱身',
  '核心':'核心',
  '拉伸':'拉伸',

  '请选择布置方式':'請選擇佈置方式',
  '请选择应用终端':'請選擇應用終端',
  '项目列表不能为空':'項目列表不能為空',
  '作业保存成功！':'作業保存成功！',
  '编辑项目':'編輯項目',
  '新增项目':'新增項目',
  '请选择运动项目':'請選擇運動項目',
  '请填写运动强度':'請填寫運動強度',
  '运动强度填写错误':'運動強度填寫錯誤',
  '确认要删除运动项目【{sportSkuName}】吗？':'確認要刪除運動項目【{sportSkuName}】嗎？',
  '删除成功!':'刪除成功!',

  '确认要返回吗？':'確認要返回嗎？!',
  '返回后，页面数据不做保存':'返回後，頁面數據不做保存!',

  // 數據頁相關
  '作业班级数据':'作業班級數據',
  '日期':'日期',
  '班级概况':'班級概況',
  '参与率':'參與率',
  '打卡率':'打卡率',
  '达标率':'達標率',
  '班级详情':'班級詳情',
  '打卡情况':'打卡情況',
  '达标情况':'達標情況',
  '请输入姓名或学籍号':'請輸入姓名或學籍號',
}
